import { Roll, ROLL_INITIAL_VALUES } from "./Roll";

export interface UniversalRoll extends Roll {
	DonutDiameter: number | null;
	DonutNewDiameter: number | null;
	DonutScrapDiameter: number | null;
	DonutPartId: number | null;
	DonutPartName: string | null;
	ArborPartId: number | null;
	ArborPartName: string | null;
	PercentUsage: number | null;
	CampaignTons: number | null;
	TotalTons: number | null;
	Sections: string;
	Stands: string;
	SectionFamilyIds: string | null;
	IsActive: boolean | null;
}

export const UNIVERSAL_ROLL_INITIAL_VALUES: UniversalRoll = {
	...ROLL_INITIAL_VALUES,
	DonutDiameter: null,
	DonutNewDiameter: null,
	DonutScrapDiameter: null,
	DonutPartId: null,
	DonutPartName: "",
	ArborPartId: null,
	ArborPartName: "",
	PercentUsage: null,
	CampaignTons: null,
	TotalTons: null,
	Sections: "",
	Stands: "",
	SectionFamilyIds: null,
	IsActive: true,
};
